module.exports = __webpack_public_path__ + "img/camper_exteriour_4.ebd969c1.jpg";